jQuery(function ($) {
	const SSS_Scripts = {
		varInit() {
			this.body = $('body');
			this.header = $("header");
			this.document = $(document);
		},

		headerScripts: function() {
			let ctrl = this;
			let menuBtn = $('.burger-btn');
			let searchBtn = $('.header__search-btn');
			let bg = $('.cover-bg');

			menuBtn.click(function () {
				$('html,body').animate({ scrollTop: 0 }, 'fast');
				ctrl.body.removeClass('search-open');
				searchBtn.removeClass('active');
				ctrl.body.toggleClass('menu-open');
				$(this).toggleClass('active');
			});

			searchBtn.click(function () {
				$('html,body').animate({ scrollTop: 0 }, 'fast');
				ctrl.body.removeClass('menu-open');
				menuBtn.removeClass('active');
				ctrl.body.toggleClass('search-open');
				$(this).toggleClass('active');
			});

			bg.click(function () {
				ctrl.body.removeClass('menu-open');
				ctrl.body.removeClass('search-open');
				menuBtn.removeClass('active');
				searchBtn.removeClass('active');
			});

			let mobParentMenu = $('.menu-mobile .menu-item-has-children');
			mobParentMenu.click(function(){
				if ($(this).hasClass('active')) {
					$(this).removeClass('active');
					$(this).find('.sub-menu').slideUp(250);
				} else {
					mobParentMenu.removeClass('active');
					$('.sub-menu').slideUp(250);
					$(this).addClass('active');
					$(this).find('.sub-menu').slideDown(250);
				}
			});
		},

		svgMapScripts: function() {
			let regionItem = $('.map__region');
			let defaultBlock = $('.activities-default-content');
			let regionBlock = $('.activities-region-content');
			let regionBlockShow = false;
			let regionTitle = $('.activities-region-title');
			let regionNews = $('.activities-region-news');

			regionItem.click(function(){
				if (!regionBlockShow) {
					defaultBlock.hide();
					regionBlock.show();
					regionBlockShow = true;
				}
				regionItem.removeClass('active');
				$(this).addClass('active');
				regionTitle.html($(this).data('region'));
				regionNews.html('');

				let data = {
					'action'	: 'region_news',
					'region-id' : $(this).data('region-id')
				};
				$.ajax({
					url:ajaxurl,
					data:data,
					type:'POST',
					beforeSend: function( xhr){
						$('.loader-wrap').removeClass('hide');
					},
					complete: function() {
						$('.loader-wrap').addClass('hide');
					},
					success:function(data){
						let res = JSON.parse(data);
						if (res !== ''){
							regionNews.html(res);
							SSS_Scripts._svgMapSlider();
						}
					}
				});

			});
		},

		_svgMapSlider: function() {
			const swiper = new Swiper(".swiper", {
				slidesPerView: 'auto',
				scrollbar: {
					el: ".swiper-scrollbar",
					hide: true,
				},
				freeMode: {
					enabled: true,
					sticky: true,
				},
			});
		},

		filters: function() {
			let filterBtn = $('.filter__btn');
			let filterItem = $('.filter-list-item');
			let accept = $('.filter-control__accept');
			let reset = $('.filter-control__reset');
			let areaButtons = $('.filter-block__button--area');
			let idp_councilButtons = $('.filter-block__button--idp_council')

			areaButtons.click(function() {
				if ($(this).hasClass('checked')) return;
				areaButtons.removeClass('checked');
				$(this).addClass('checked');
				SSS_Scripts._getFilterPosts();
			});


			idp_councilButtons.click(function() {
				if ($(this).hasClass('checked')) return;
				idp_councilButtons.removeClass('checked');
				$(this).addClass('checked');
				SSS_Scripts._getFilterPosts();
			});
			
			
			
			filterBtn.click(function(){
				if ($(this).hasClass('filter-open')) {
					$(this).removeClass('filter-open');
					$(document).off('click.filterDropdown');
				} else {
					let filterDropdown = $(this).next('.filter-dropdown');
					filterBtn.removeClass('filter-open');
					$(document).off('click.filterDropdown');
					$(this).addClass('filter-open');
					$(document).on('click.filterDropdown', function (e) {
						if ( !filterBtn.is(e.target) && filterBtn.has(e.target).length === 0 && !filterDropdown.is(e.target) && filterDropdown.has(e.target).length === 0) {
							filterBtn.removeClass('filter-open');
							setTimeout(function(){
								$(document).off('click.filterDropdown');
							}, 500);	
						};
					});
				}
			});

			filterItem.click(function(){
				if ($(this).hasClass('single-choice')) {
					$(this).siblings().removeClass('active');
					$(this).addClass('active');
				} else {
					$(this).toggleClass('active');
				}
				let filterParams = SSS_Scripts._getParameters();
			});

			accept.click(function(){
				SSS_Scripts._getFilterPosts();
			});

			reset.click(function(){
				filterItem.removeClass('active');
				if (areaButtons.length) {
					areaButtons.removeClass('checked').first().addClass('checked');
				}
				SSS_Scripts._getFilterPosts();
			});
		},

		_getFilterPosts: function() {
			console.log("GET FLTR")
			let l = '';
			if (lang != 'uk') {
				l = '/' + lang;
			}
			let postType = $('.filters-block').data('type');
			let filterParams = SSS_Scripts._getParameters();

			let data = {
				'action': 'filters',
				'postType': postType,
				'regions': filterParams['regions'],
				'target-audience': filterParams['targets'],
				'categories': filterParams['categories'],
				'projects': filterParams['projects'],
				'activityarea': filterParams['activityarea'],
				'idpCouncil': filterParams['idpCouncil'],
				'urlParam': filterParams['parameters']
			};

			// Формування основного URL
			let newUrl = window.location.origin + l + '/' + postType + '/' + filterParams['parameters'];
			// Якщо в поточній URL присутній параметр idp-council=show, додаємо його до нового URL			
			// if (window.location.href.indexOf('idp-council=show') !== -1) {
			// 	newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + 'idp-council=show';
			// 	data['idpCouncil'] = 'show';
			// }
			history.pushState('', '', newUrl);

			$.ajax({
				url: ajaxurl,
				data: data,
				type: 'POST',
				beforeSend: function(xhr) {
					$('.loader-wrap').removeClass('hide');

					console.log('data', data)
				},
				complete: function() {
					$('.loader-wrap').addClass('hide');
				},
				success: function(data) {
					let res = JSON.parse(data);

					console.log(res);
					
					if (res.posts !== '') {
						$('.useful-materials-wrap, .news-wrap, .projects-wrap').html(res.posts);
					}
					$('.pagination').html(res.pagination);
				}
			});
		},

		_updFilterParams: function() {
			const urlParams = new URLSearchParams(window.location.search);
			const activityArea = urlParams.get('activity-area');
			const idp_council = urlParams.get('idp-council');
		
			if (activityArea) {
				$('.filter-block__button--area').removeClass('checked');
				const targetButton = $('.filter-block__button--area[data-area="' + activityArea + '"]');
				if (targetButton.length) {
					targetButton.addClass('checked');
				}
			};
			if (idp_council) {
				$('.filter-block__button--idp_council').removeClass('checked');
				const targetButton = $('.filter-block__button--idp_council[data-idp-council="' + activityArea + '"]');
				if (targetButton.length) {
					targetButton.addClass('checked');
				}
			};
		},
		

		_getFilterParams: function() {
			let filterParam = [];

			filterParam['regions'] = [];
			$('.filter-list-item--regions.active').each(function() {
				filterParam['regions'].push($(this).data('region'));
			});
			filterParam['categories'] = [];
			$('.filter-list-item--categories.active').each(function() {
				filterParam['categories'].push($(this).data('category'));
			});
			filterParam['targets'] = [];
			$('.filter-list-item--targets.active').each(function() {
				filterParam['targets'].push($(this).data('target'));
			});

			// filterParam['activityarea'] = [];
			// filterParam['activityarea'] = $('.filter-block__button--area.checked').data('area');

			// filterParam['idpCouncil'] = [];
			// filterParam['idpCouncil'] = $('.filter-block__button--idp_council.checked').data('idp_council');

			filterParam['projects'] = [];
			filterParam['projects'] = $('.filter-list-item--projects.active').data('project');


			// Фільтрація activityarea
			let activityArea = $('.filter-block__button--area.checked').data('area');
			if (activityArea !== undefined && activityArea !== 'all') {
				filterParam['activityarea'] = activityArea;
			}
		
			// Фільтрація idpCouncil
			let idpCouncil = $('.filter-block__button--idp_council.checked').data('idp_council');
			if (idpCouncil !== undefined && idpCouncil !== 'all') {
				filterParam['idpCouncil'] = idpCouncil;
			}

			return filterParam;
		},

		_getParameters: function() {
			let parameters = '';
			let filterParams = SSS_Scripts._getFilterParams();
			
			if (filterParams['regions'] && filterParams['regions'].length) {
				parameters += '&regions=' + filterParams['regions'];
				$('.filter--regions').addClass('checked');
			} else {
				$('.filter--regions').removeClass('checked');
			}
			if (filterParams['categories'] && filterParams['categories'].length) {
				parameters += '&categorization=' + filterParams['categories'];
				$('.filter--categories').addClass('checked');
			} else {
				$('.filter--categories').removeClass('checked');
			}
			if (filterParams['targets'] && filterParams['targets'].length) {
				parameters += '&target-audience=' + filterParams['targets'];
				$('.filter--targets').addClass('checked');
			} else {
				$('.filter--targets').removeClass('checked');
			}
			if (filterParams['projects']) {
				parameters += '&project=' + filterParams['projects'];
				$('.filter--projects').addClass('checked');
			} else {
				$('.filter--projects').removeClass('checked');
			}
			if (filterParams['activityarea'] && filterParams['activityarea'].length) {
				parameters += '&activity-area=' + filterParams['activityarea'];
			} 		
			if (filterParams['idpCouncil'] && filterParams['idpCouncil'].length) {
				parameters += '&idp-council=' + filterParams['idpCouncil'];
				$('.filter--category').addClass('checked');
			} else {
				$('.filter--category').removeClass('checked');
			}
			if (parameters.length) {
				parameters = '?'+ parameters.slice(1);
				$('.filter-control__accept').removeClass('disabled');
				$('.filter-control__reset').removeClass('disabled');
			} else {
				$('.filter-control__accept').addClass('disabled');
				$('.filter-control__reset').addClass('disabled');
			}

			filterParams['parameters'] = parameters;

			return filterParams;
		},


		contentSlider: function() {
			const blockSliders = document.getElementsByClassName('block-slider');
			for (let blockSlider of blockSliders) {
				const slider = blockSlider.getElementsByClassName('content-slider')[0];
				const nextEl = blockSlider.getElementsByClassName('block-slider-button-next')[0];
				const prevEl = blockSlider.getElementsByClassName('block-slider-button-prev')[0];
				const paginate = blockSlider.getElementsByClassName('block-slider-pagination')[0];
				let swiper = new Swiper(slider, {
					loop: true,
					pagination: {
						el: paginate,
						type: "fraction",
					},
					navigation: {
						nextEl: nextEl,
						prevEl: prevEl,
					},
					speed: 700,
					effect: "creative",
					creativeEffect: {
						prev: {
							shadow: true,
							translate: ["-20%", 0, -1],
						},
							next: {
							translate: ["100%", 0, 0],
						},
					}
				});
			}
		},

		init() {
			SSS_Scripts.varInit();
			SSS_Scripts.headerScripts();
			SSS_Scripts.svgMapScripts();
			// SSS_Scripts._updFilterParams();
			SSS_Scripts.filters();
			SSS_Scripts.contentSlider();
		},
	};

	$(document).ready(function () {
		SSS_Scripts.init();
	});
});  


// loadmore
